import React from 'react';
 

import Header from '../components/Home/Header';
import Section1 from '../components/Home/Section1';
import Section2 from '../components/Home/Section2';
import Section3 from '../components/Home/Section3';
import Section4 from '../components/Home/Section4';
import Section5 from '../components/Home/Section5';
import Section6 from '../components/Home/Section6';
import Section7 from '../components/Home/Section7';
import Footer from '../components/classic/Footer';

const Home = () => {
    return ( <div>
        <Header />
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 />
        <Footer />
        
    </div> );
}
 
export default Home;